import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Picture } from 'formlabs-web-components/Media';
import { GridContainer, Grid, Cell } from 'formlabs-web-components/Grid';
import { Link } from 'formlabs-web-components/Link';
import chunk from 'lodash/chunk';
import debounce from 'lodash/debounce';
import { withTranslation } from 'react-i18next';

import SocialMediaIcons from '../content/SocialMediaIcons';
import CountryContext from '../../context/country';
import FooterMenu from './FooterMenu';
import FooterMenuMobile from './FooterMenuMobile';
import NewsletterSignUp from '../forms/NewsletterSignUp';
import classnames from 'classnames';
import logoBlack from '../../../../public/logo_black.svg';
import logoWhite from '../../../../public/logo_white.svg';

import { CountrySelectionModal } from '../../../sites/formlabs/components/countrySelection/CountrySelection';

import './Footer.module.css';

const pickLogo = color => {
  const logos = {
    black: logoBlack,
    white: logoWhite
  };

  if (logos[color]) return logos[color];
  return logos['black'];
};
class Footer extends PureComponent {
  state = {
    mobile: false,
    submitting: false,
    submitted: false
  };

  static contextType = CountryContext;

  componentDidMount() {
    window.addEventListener('resize', this.debouncedResize);
    this.resize();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResize);
  }
  resize = () => {
    this.setState({ mobile: window.innerWidth <= 1023 });
  };

  debouncedResize = debounce(this.resize, 100);

  render() {
    const { menu, countrySite, t, countries, white } = this.props;
    const { mobile } = this.state;
    const { path } = this.context;
    const splitMenu = chunk(menu, 2);
    return (
      <nav
        styleName={classnames('footer', { white: white })}
        aria-label={t('Page footer navigation')}
      >
        <GridContainer>
          <Grid direction="x" primaryAlignment="align-center" gutters="margin">
            <Cell largeSize={4}>
              <div styleName="footer-logo">
                <Picture
                  largeImage={pickLogo(white ? 'black' : 'white')}
                  lazyload={false}
                  width={145}
                  alt={t('Formlabs logo')}
                />
              </div>

              <p>
                <CountrySelectionModal countries={countries}>
                  <div styleName="region-select">
                    <Picture
                      largeImage={countrySite.regionFlag}
                      width={32}
                      alt={t('country flag')}
                    />{' '}
                    <span styleName="region-text">{t('Change Region')}</span>
                  </div>
                </CountrySelectionModal>
              </p>
            </Cell>
            {!mobile && <FooterMenu splitMenu={splitMenu} />}
            {mobile && <FooterMenuMobile data={menu} />}

            <Cell largeSize={7} largeOffset={1}>
              <p styleName="email-area">
                {t('Enter your email address for updates')}
              </p>
              <NewsletterSignUp layoutType="default" />

              <SocialMediaIcons
                color={white ? 'black' : 'white'}
                iconSize="1.33rem"
                spaceBetween="1.1rem"
                align="left"
              />
            </Cell>
          </Grid>
        </GridContainer>
        <div styleName="bottom-most-footer">
          <GridContainer>
            <Grid direction="x" primaryAlignment="align-justify">
              <Cell largeSize={4} largeOrder="1" mediumOrder="2" smallOrder="2">
                © Formlabs {new Date().getFullYear()}
              </Cell>
              <Cell largeSize={8} largeOrder="2">
                <div styleName="bottom-links">
                  <Link to={`${path}privacy-policy/`}>
                    {t('Privacy Policy')}
                  </Link>
                  {' · '}
                  <Link to={`${path}terms-of-service/`}>
                    {t('Terms of Service')}
                  </Link>
                  {' · '}
                  <Link
                    to={`https://support.formlabs.com/s/topic/0TO1Y000000Iw01WAC/faq?language=${
                      countrySite.language
                    }`}
                  >
                    {t('FAQ')}
                  </Link>
                </div>
              </Cell>
            </Grid>
          </GridContainer>
        </div>
      </nav>
    );
  }
}

Footer.propTypes = {
  menu: PropTypes.array.isRequired
};

export default withTranslation()(Footer);
